var _circle, _path, _path2, _path3, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7015,
    cy: 13.9499,
    r: 13.7044,
    fill: "#00285B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7049 10.3826C14.3153 10.3826 14.8101 10.8774 14.8101 11.4878V19.6821C14.8101 20.2925 14.3153 20.7873 13.7049 20.7873C13.0945 20.7873 12.5997 20.2925 12.5997 19.6821V11.4878C12.5997 10.8774 13.0945 10.3826 13.7049 10.3826Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7258 19.6819C16.7258 20.2922 16.231 20.7871 15.6206 20.7871L11.7822 20.7871C11.1718 20.7871 10.677 20.2922 10.677 19.6819C10.677 19.0715 11.1718 18.5767 11.7822 18.5767L15.6206 18.5767C16.231 18.5767 16.7258 19.0715 16.7258 19.6819Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7397 11.0445C14.9485 11.618 14.653 12.2526 14.0796 12.4619L12.2764 13.12C11.7031 13.3293 11.069 13.034 10.8601 12.4604C10.6513 11.8869 10.9468 11.2523 11.5202 11.043L13.3234 10.3849C13.8968 10.1756 14.5309 10.4709 14.7397 11.0445Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6171,
    cy: 7.80156,
    r: 1.36061,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.75c27be143319484b0403b4bf99c0d62.svg";
export { ForwardRef as ReactComponent };